import { useMutation } from "react-query"
import reportService from "api/reportService"

const useGetReportBoxes = () => {
  return useMutation(async (data: number[]) => {
    const res = await reportService.getReportBoxes(data)

    return res.data
  })
}

export default useGetReportBoxes
